import { useEffect } from "react";

export const SITE_URL = "https://aelvir.fr";

// Doit rester aligné sur public/index.html.
// « Organisme de formation » est proscrit ici : le statut existe mais ne
// doit apparaître que dans les mentions légales.
const DEFAULT_TITLE =
  "Aëlvir · Studio de serious games et de formations en réalité virtuelle";
const DEFAULT_DESC =
  "Aëlvir crée des dispositifs de formation, serious games 2D/3D et réalité virtuelle. Éditeur de Cywiz, application de sensibilisation à la cybersécurité déjà déployée.";

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, name] = selector.match(/\[(?:name|property)="([^"]+)"\]/) || [];
    if (!name) return;
    el.setAttribute(selector.includes("property") ? "property" : "name", name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setCanonical = (path) => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : SITE_URL;
  link.setAttribute("href", origin + path);
};

/**
 * Met à jour title / description / Open Graph / canonical pour la page courante.
 * CRA ne fait pas de rendu serveur : ces balises servent au partage et aux
 * crawlers qui exécutent le JS. Pour un SEO complet, prévoir un prérendu.
 */
export const useSeo = ({ title, description, path } = {}) => {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    document.title = t;
    setMeta('meta[name="description"]', "content", d);
    setMeta('meta[property="og:title"]', "content", t);
    setMeta('meta[property="og:description"]', "content", d);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:url"]', "content", SITE_URL + (path || "/"));
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    if (path) setCanonical(path);
  }, [title, description, path]);
};
